var angular = require('angular');

var t = require('js/lib/translate').t;

function File(file) {
  angular.extend(this, file);
}

File.prototype.customerSystemIds = function(customers) {
  if (this.customerSystemId) {
    return [this.customerSystemId];
  }

  return customers
    .filter(function(customer) {
      return customer.fileId === this.id;
    }, this)
    .map(function(customer) {
      return customer.customerSystemId;
    })
    .filter(function(id, index, list) {
      return list.indexOf(id) === index;
    });
};

File.prototype.statusClass = function() {
  if (this.id === File.individual.id) return 'manual';
  if (this.status === 0) return 'uploading';
  if (this.status === 1) return 'linking';
  if (this.status === 3) return 'error';
  return 'done';
};

File.prototype.errorMessage = function(key, map) {
  var fieldName, fieldValue;

  if (map && map['user.import.file.error.incomplete.row']) {
    var rowNumber = map['user.import.file.error.incomplete.row'];
    return t('planFilesIncompleteRowError', rowNumber);
  } else if (map && map['user.import.file.error.missing.property.name']) {
    fieldName = map['user.import.file.error.missing.property.name'];
    return t('planFilesMissingPropertyNameError', fieldName);
  } else if (map && map['user.import.file.error.invalid.property.length']) {
    fieldName = map['user.import.file.error.invalid.property.length'];
    return t('planFilesInvalidPropertyLengthError', fieldName);
  } else if (map && map['user.import.file.error.duplicate.order-line-ids']) {
    fieldName = map['user.import.file.error.duplicate.order-line-ids'];
    return t('planFilesDuplicateOrderLineIdError', fieldName);
  } else if (map && map['user.import.file.error.duplicate.parcel-numbers']) {
    fieldName = map['user.import.file.error.duplicate.parcel-numbers'];
    return t('planFilesDuplicateParcelNumberError', fieldName);
  } else if (map && map['user.import.file.error.duplicate.header']) {
    details = map['user.import.file.error.duplicate.header'];
    return details;
  } else if (map && map['user.import.file.error.unknown.header']) {
    columnNames = map['user.import.file.error.unknown.header'];
    return t('planFilesUnknownHeaderError', columnNames);
  } else if (key === 'user.import.file.error.unsupported-file-type') {
    return t('planFilesUnknownFileTypeError');
  } else if (key === 'user.import.file.datatype.error') {
    for (fieldName in map) {  // There should be only one entry
      fieldValue = map[fieldName];
    }
    return t('planFilesDatatypeError', fieldValue, fieldName);
  } else if (key === 'linker.failed') {
    return t('planFilesAddressLinkerError');
  } else {
    return t('planFilesUnknownError');
  }
};

File.individual = new File({
  id: 'individual',
  name: t('planFilesIndividual')
});

module.exports = File;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/file.js
 ** module id = 7
 ** module chunks = 1
 **/